import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import chatReducer from './chatReducer';
import userReducer from './userReducer';
import authenticationReducer from './authenticationReducer';
import selectedSearchReducer from './selectedSearchReducer';
import proposalsReducer from './proposalsReducer';
import searchFilters from './searchFilters';
import intervalReducer from './intervalsReducer';
import matchedOriganizationReducer from './matchedOriganizationReducer';
import permissionReducer from './permissionReducer';

export default combineReducers({
  chat: chatReducer,
  auth: authenticationReducer,
  user: userReducer,
  selectedSearch: selectedSearchReducer,
  allFilters: searchFilters,
  form: formReducer,
  proposals: proposalsReducer,
  intervals: intervalReducer,
  matched_organization: matchedOriganizationReducer,
  permissions: permissionReducer,
});
